import DoneIcon from "@mui/icons-material/Done";
import CloseIcon from "@mui/icons-material/Close";

interface AlertProps {
  isMet: boolean;
  text: string;
}
const AlertText = (props: AlertProps) => {
  const { isMet, text } = props;
  const metStyle = { color: "green", display: "flex" };
  const notMetStyle = { color: "red", display: "flex" };
  const GetIcon = ({ value }: { value?: boolean }) => {
    return value ? <DoneIcon /> : <CloseIcon />;
  };
  return (
    <div>
      <span style={isMet ? metStyle : notMetStyle}>
        <GetIcon value={isMet} />
        {text}
      </span>
    </div>
  );
};

export default AlertText;
